import React from 'react';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';

const SaveStatus = ({ dirty }) => (
    <Box
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            fontSize: 11.5,
            height: 24,
            px: 1.1,
            borderRadius: 12,
            border: '1px solid',
            ...(dirty
                ? {
                    backgroundColor: 'var(--warn-soft)',
                    borderColor: '#F0DCBB',
                    color: 'var(--warn)',
                    fontWeight: 500,
                }
                : {
                    backgroundColor: 'var(--surface-2)',
                    borderColor: 'var(--line-2)',
                    color: 'var(--muted)',
                }),
        }}
    >
        {dirty
            ? (
                <>
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'currentColor' }} />
                    Есть несохранённые изменения
                </>
            )
            : (
                <>
                    <CheckIcon sx={{ fontSize: 13 }} />
                    Все изменения сохранены
                </>
            )
        }
    </Box>
);

export default SaveStatus;
